import Popover from "@rio-cloud/rio-uikit/components/popover/Popover";
import styled from "styled-components";

export const ActionButtonWrapper = styled.div`
    display: flex;
    margin-top: 15px;
    justify-content: flex-start;
    align-items: flex-start;
    height: 10px;
    font-size: 2.5rem;
    color: var(--gray-darkest);

    & > .rioglyph {
        position: relative;
        top: 2px;
        left: 14px;
    }
`;

export const Toolbar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-top: 15px;
`;

export const CustomPopover = styled(Popover)`
    border-radius: 6px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1) !important;
    border: none;

    & .arrow {
        display: none;
    }

    & .popover-content {
        padding: 0 1.2rem !important;
    }
`;

export const Divider = styled.div`
    width: 1px;
    height: 20px;
    background-color: var(--gray-light);
`;
